module.exports = __webpack_public_path__ + "static/media/chip_20.a717721b.png";